(function() {
  var productId = window.location.pathname;
  var cacheKey = 'shipping_date_' + productId;
  
  var cachedData = localStorage.getItem(cacheKey);
  var shippingDate;
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  
  if (cachedData) {
    var cached = new Date(cachedData);
    cached.setHours(0, 0, 0, 0);
    
    if (cached <= today) {
      localStorage.removeItem(cacheKey);
      cachedData = null;
    } else {
      shippingDate = cached;
    }
  }
  
  if (!cachedData) {
    var daysToAdd = Math.floor(Math.random() * 3) + 1;
    shippingDate = new Date(today);
    shippingDate.setDate(today.getDate() + daysToAdd);
    localStorage.setItem(cacheKey, shippingDate.toISOString());
  }
  
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  
  var dayName = days[shippingDate.getDay()];
  var monthName = months[shippingDate.getMonth()];
  var date = shippingDate.getDate();
  
  var formattedDate = dayName.substring(0, 3) + ', ' + monthName + ' ' + date;
  
  var shippingHTML = `
    <div class="shipping-info-container">
      <div class="shipping-date">
        <span class="shipping-dot"></span>
        <span class="shipping-text">Ships by <strong>` + formattedDate + `</strong></span>
      </div>
      <div class="free-shipping">
        <img src="https://flagcdn.com/w20/gb.png" alt="UK Flag" class="uk-flag">
        <img src="https://flagcdn.com/w20/us.png" alt="USA Flag" class="uk-flag">
        <img src="https://flagcdn.com/w20/ca.png" alt="Canada Flag" class="uk-flag">
        <img src="https://flagcdn.com/w20/eu.png" alt="Europe Flag" class="uk-flag">
        <span class="free-text"><strong>Free</strong> Shipping</span>
      </div>
    </div>
  `;

  var clearanceHTML = `
    <div class="clearance-sale-box-custom">
      <h3 class="clearance-title">SEASONAL SALE UPDATE</h3>
      <p class="clearance-text">A seasonal refresh is here. Discover last-chance styles with up to 40% off before they make way for what's next.</p>
    </div>
  `;

  var style = document.createElement('style');
  style.textContent = `
    .shipping-info-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 15px 0 0 0;
      padding: 12px 15px;
      background: #f5f5f5;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
    }

    .shipping-date {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .shipping-dot {
      width: 10px;
      height: 10px;
      background: #00ff00;
      border-radius: 50%;
    }

    .shipping-text {
      font-size: 14px;
      color: #333;
    }

    .free-shipping {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .uk-flag {
      width: 20px;
      height: auto;
    }

    .free-text {
      font-size: 14px;
      color: #333;
    }

    .clearance-sale-box-custom {
      background: #ffe6e6 !important;
      border: 1px solid #ffcccc !important;
      border-radius: 4px !important;
      padding: 20px !important;
      margin: 20px 0 0 0 !important;
      text-align: center !important;
      display: block !important;
    }

    .clearance-sale-box-custom .clearance-title {
      color: #cc0000 !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin: 0 0 10px 0 !important;
      letter-spacing: 0.05em !important;
    }

    .clearance-sale-box-custom .clearance-text {
      color: #333 !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      margin: 0 !important;
    }

    .guarantee__safe__checkout {
      background: transparent !important;
      background-color: transparent !important;
      padding: 0 !important;
    }

    .guarantee__safe__checkout > p {
      display: none !important;
    }

    .product-single__wishlist,
    .wishlist-button,
    [class*="wishlist"] {
      display: none !important;
    }

    @media (max-width: 768px) {
      .shipping-info-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
    }
  `;

  document.head.appendChild(style);

  function insertElements() {
    if (document.querySelector('.shipping-info-container')) return;

    // Only target the main product form, scoped to the product detail section
    // Exclude any product-form inside d-md-none wrappers
    var allProductForms = document.querySelectorAll('product-form');
    var visibleProductForm = null;

    allProductForms.forEach(function(pf) {
      if (!pf.parentElement.classList.contains('d-md-none') && !visibleProductForm) {
        // Make sure this is the MAIN product form, not a related product
        // Check it's inside a product detail section, not a card
        var isInCard = pf.closest('.product-card') || 
                       pf.closest('.card') || 
                       pf.closest('[class*="product-card"]') ||
                       pf.closest('[class*="grid__item"]');
        if (!isInCard) {
          visibleProductForm = pf;
        }
      }
    });

    if (visibleProductForm) {
      var shippingDiv = document.createElement('div');
      shippingDiv.innerHTML = shippingHTML;
      visibleProductForm.insertAdjacentElement('afterend', shippingDiv);
    }

    var guaranteeCheckout = document.querySelector('.guarantee__safe__checkout');
    
    if (guaranteeCheckout) {
      if (document.querySelector('.clearance-sale-box-custom')) return;
      var paymentList = guaranteeCheckout.querySelector('.list');
      
      if (paymentList) {
        var clearanceDiv = document.createElement('div');
        clearanceDiv.innerHTML = clearanceHTML;
        paymentList.insertAdjacentElement('afterend', clearanceDiv);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertElements);
  } else {
    insertElements();
  }
  
  setTimeout(insertElements, 500);
  setTimeout(insertElements, 1000);
  setTimeout(insertElements, 1500);
})();